module.exports = __webpack_public_path__ + "media/images/logo-20minutes-8993169fa18dd4a62a66a39dccd5ed9a.png";